<template>
    <div :class="$style.drag_area">
        <slot/>
    </div>
</template>

<style lang="scss" module>
.drag_area {
    cursor: pointer;

    &:active {
        cursor: grabbing;
    }
    > * {
        cursor: inherit;
    }
}
</style>
